import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { RoomIdService } from '../poker-room/room-id.service';
import { ResponsiveService } from '../common/responsive.service';
import { NGXLogger as LoggerService } from "ngx-logger";

export interface DialogData {
    title: string;
    okLabel: string;
    cancelLabel: string;
    description1: string;
    description2: string;
    description3: string;
    label: string;
    maxEntries: string;
    delete: boolean;
    edit: boolean;
}

@Component({
    selector: 'ok-cancel-dialog',
    templateUrl: 'ok-cancel-dialog.component.html',
    styleUrls: ['ok-cancel-dialog.component.scss']
})

export class OkCancelDialogComponent {
    constructor(
        public logger: LoggerService,
        public roomIdService: RoomIdService,
        public responsiveService: ResponsiveService,
        public dialogRef: MatDialogRef<OkCancelDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: DialogData,
        public dialog: MatDialog
    ) {
    }

    onNoClick(): void {
        this.dialogRef.close();
    }
}
